import api, { apiRequest } from './api';
import type { AuthResponse, User, UserProfile } from '@shared/types';

export const authService = {
  /**
   * Registrar nuevo usuario
   */
  async register(data: {
    username: string;
    email: string;
    password: string;
    rol?: string;
  }): Promise<AuthResponse> {
    return apiRequest<AuthResponse>(
      api.post('/auth/register', data)
    );
  },

  /**
   * Login
   */
  async login(data: {
    usernameOrEmail: string;
    password: string;
  }): Promise<AuthResponse> {
    return apiRequest<AuthResponse>(
      api.post('/auth/login', data)
    );
  },

  /**
   * Logout
   */
  async logout(): Promise<void> {
    await api.post('/auth/logout');
  },

  /**
   * Obtener usuario actual
   */
  async me(): Promise<{ user: User; profile?: UserProfile }> {
    return apiRequest<{ user: User; profile?: UserProfile }>(
      api.get('/auth/me')
    );
  },

  /**
   * Actualizar perfil
   */
  async updateProfile(data: Partial<UserProfile>): Promise<void> {
    await api.put('/auth/profile', data);
  },

  /**
   * Cambiar contraseña
   */
  async changePassword(data: {
    currentPassword: string;
    newPassword: string;
  }): Promise<void> {
    await api.post('/auth/change-password', data);
  },

  /**
   * Solicitar recuperación de contraseña
   */
  async forgotPassword(email: string): Promise<void> {
    await api.post('/auth/forgot-password', { email });
  },

  /**
   * Resetear contraseña
   */
  async resetPassword(data: {
    token: string;
    newPassword: string;
  }): Promise<void> {
    await api.post('/auth/reset-password', data);
  },
};
